import { useSelector } from "react-redux";
import DotLoader from "react-spinners/DotLoader";
import styles from "@/helper/global/globalComponents.module.css";
import { RootState } from "@/components/state/store";
import { useTranslation } from "react-i18next";

export default function GlobalLoader() {
  const { t } = useTranslation();
  const { count, translationKey, translationParams } = useSelector(
    (state: RootState) => state.loading
  );

  if (count === 0) return null;

  return (
    <div className={styles.loader_overlay} data-testid="global-loader">
      <div className={styles.loader_with_heading}>
        <DotLoader color="#8c1ec8" size={65} />
        {translationKey && (
          <h1>
            {translationParams
              ? t(translationKey, translationParams)
              : t(translationKey)}
          </h1>
        )}
      </div>
    </div>
  );
}
